/**
 * The 5D dashboard's WBS numbering scheme, in one place.
 *
 * Stored estimation rows keep their stable internal codes ("1.1" ... "4.2") -
 * that is the key EstimationTab merges user-typed rates on and the key saved
 * revisions already carry, so it must not be rewritten. What the dashboard
 * SHOWS is derived from it: "{vessel tag}.{sequence}", e.g. V201.25, with room
 * left in each block (1-24 / 25-49 / 50-74 / 75-99) for lines added later.
 * Once MRQs reference a code like V201.25 the numbering must stay frozen.
 *
 * If clients ever need different numbering, this is the module to back with a
 * settings table instead of constants.
 */

// How a category's cost actually leaves the building - payroll, a material
// vendor, or a subcontractor - which is what sets its vendor/payout lag in the
// switch model (switchLink.js). Not the same axis as `sys`/`entity`: it's
// about the disbursement mechanism, not the WBS classification.
export const PAYOUT_TYPES = ["manhour", "material", "subcontract"];

export const CATEGORIES = [
  { k: "1", code: "COE", name: "Engineering", unit: "Nos", sys: "EMS", entity: "Document", discipline: "engineering", payoutType: "manhour" },
  { k: "2", code: "COP", name: "Procurement", unit: "Kg", sys: "PMS", entity: "Material", discipline: "procurement", payoutType: "material" },
  { k: "3", code: "CPF", name: "Fabrication & Inspection", unit: "Manhours", sys: "CMS", entity: "Shop", discipline: "fabrication", payoutType: "manhour" },
  // Subcontract has no invoice discipline in the plant MIS.
  { k: "4", code: "CPS", name: "Subcontract", unit: "Kg", sys: "PMS", entity: "Shop", discipline: null, payoutType: "subcontract" },
];

// internal code -> display sequence, plus the dashboard-only label/unit where
// the wording differs from what the Estimation tab stores.
export const LINE_DEFS = {
  "1.1": { seq: 1 },
  "1.2": { seq: 2 },
  "1.3": { seq: 3 },
  "1.4": { seq: 4 },
  "2.1": { seq: 25 },
  "2.2": { seq: 26 },
  "2.3": { seq: 27 },
  "3.1": { seq: 50 },
  "3.2": { seq: 51 },
  "3.3": { seq: 52 },
  "3.4": { seq: 53 },
  "4.1": { seq: 75 },
  "4.2": { seq: 76, label: "Ext. Painting", unit: "Sq.m" },
};

/**
 * "V201" + "2.1" -> "V201.25". Without a vessel tag (or for a code with no
 * sequence) the internal code is shown as-is, so a line is never unlabeled.
 */
export const displayCode = (tag, code) => {
  const seq = LINE_DEFS[code]?.seq;
  const t = String(tag ?? "").trim();
  return t && seq != null ? `${t}.${seq}` : code;
};
